import CONFIGS from "build/Config";
import { dlTrackEvent } from "components/dataLayer/dataLayer";
import { useSession } from "contexts/session-context";
import { useMemo } from "react";

const SolMezclasGame = () => {
  const [{ user }] = useSession()

  const onHandleClick = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'button_game_solmezclas',
      section: 'home'
    })
    gtag('event', 'event_to_ga', { event_category: 'button_game_solmezclas', event_label: 'Home links' })
  }

  function base64UrlEncodeAscii(str: string) {
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  }

  function generateProfileHash(profileId: number) {
    const payload = `external-game-profile|${profileId}`;
    return base64UrlEncodeAscii(payload);
  }

  const url = useMemo(() => {
    if (!user?.id) return ''
    return `${CONFIGS.play_endpoint}?k=${generateProfileHash(user?.id)}`
  }, [user])

  return (
    <a href={url} target="_blank" onClick={onHandleClick} rel="noopener noreferrer" className="button-home">
      <img src={`${AZURE_BASE_URL}/button-game.webp`} className='w-full' />
    </a>
  )
}

export default SolMezclasGame